import { useState } from "react";
import { createModel } from "hox";
import { TablePaginationConfig } from "antd/es/table/interface";
import { IRealDetail, IRealSearchFields, realService } from "./realService";
import { DEFAULT_PAGE_SIZE, DEFAULT_FIRST_PAGE_NUM, defaultMdCmParam } from "@/utils/constants";
import { ISearchPage } from "@/types/FmsTypes";
import { transPgToPagination } from "@/views/base/app/appModel";
import { convertRes2Blob } from "@/utils/exportFile";
import { useLockFn } from "ahooks";


export const useRealModel = createModel(function () {
    //列表数据源
    const [dataSource, setDataSource] = useState<IRealDetail[]>([]);
    //查询条件
    const [searchParam, setSearchParam] = useState<IRealSearchFields>({});
    //分页参数
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    //表格多选id值
    const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
    const [exportLoading, setExportLoading] = useState(false)

    //设置搜索value
    const updateSearchParam = (updateParam: IRealSearchFields) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }
    //列表查询
    const loadData = async (page: ISearchPage = initPgCfg, searchValue: IRealSearchFields = searchParam) => {
        const searchParams = {
            ...searchValue,
            sourceApp: defaultMdCmParam.sourceApp,
            pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.current || page?.pageNum) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
        }
        let { retData } = await realService.page(searchParams);
        const { records, ...pg } = retData;
        setPgCfg(transPgToPagination(pg));
        setDataSource(records);
        clearSelectData();
    }

    //重置搜索参数
    const resetSearchParam = () => {
        setSearchParam({});
        setSelectedRowKeys([]);
        loadData(initPgCfg, {});
    }
    const clearSelectData = () => {
        setSelectedRowKeys([]);
    }

    //导出
    const exportApi = useLockFn(async (page: ISearchPage = initPgCfg, searchValue: IRealSearchFields = searchParam) => {
        setExportLoading(true)
        try {
            const searchParams = {
                ...searchValue,
                sourceApp: defaultMdCmParam.sourceApp,
                pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
                pageNum: (page?.current || page?.pageNum) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
            }
            let result = await realService.export(searchParams);
            convertRes2Blob(result);
            setExportLoading(false)
        } catch (error) {
            setExportLoading(false)
        }
    })

    return {
        /***field***/
        searchParam,
        dataSource,
        selectedRowKeys,
        pgCfg,
        exportLoading,
        /***method***/
        setDataSource,
        updateSearchParam,
        setSelectedRowKeys,
        resetSearchParam,
        loadData, exportApi
    }
});